(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@angular/cdk/a11y'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@angular/cdk/keycodes'), require('@material/ripple'), require('@material/list'), require('@material/drawer')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/drawer', ['exports', '@angular/core', '@angular/common', '@angular/cdk/a11y', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@angular/cdk/keycodes', '@material/ripple', '@material/list', '@material/drawer'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.drawer = {}), global.ng.core, global.ng.common, global.ng.cdk.a11y, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.ng.cdk.keycodes, global.mdc.ripple, global.mdc.list, global.mdc.drawer));
}(this, (function (exports, core, common, a11y, coercion, platform, rxjs, operators, keycodes, ripple, list, drawer) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDCComponent = /** @class */ (function () {
        function MDCComponent(elementRef, foundation) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this._elementRef = elementRef;
            this.initialize.apply(this, __spread(args));
            // Note that we initialize foundation here and not within the constructor's default param.
            this._foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        }
        /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
        MDCComponent.prototype.initialize = function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
            // initialized. Any additional arguments besides root and foundation will be passed in here.
        };
        MDCComponent.prototype.getDefaultFoundation = function () {
            // Subclasses must override this method to return a properly configured foundation class for the
            // component.
            throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                'foundation class');
        };
        MDCComponent.prototype.destroy = function () {
            var _a;
            // Subclasses may implement this method to release any resources / deregister any listeners they have
            // attached. An example of this might be deregistering a resize event from the window object.
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        return MDCComponent;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcListDivider = /** @class */ (function () {
        function MdcListDivider(elementRef) {
            this.elementRef = elementRef;
            this._inset = false;
            this._padded = false;
        }
        Object.defineProperty(MdcListDivider.prototype, "inset", {
            get: function () {
                return this._inset;
            },
            set: function (value) {
                this._inset = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListDivider.prototype, "padded", {
            get: function () {
                return this._padded;
            },
            set: function (value) {
                this._padded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcListDivider.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcListDivider], mdc-list-divider',
                        exportAs: 'mdcListDivider',
                        host: {
                            'role': 'separator',
                            'class': 'mdc-list-divider',
                            '[class.mdc-list-divider--inset]': 'inset',
                            '[class.mdc-list-divider--padded]': 'padded'
                        },
                        template: '',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListDivider.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcListDivider.propDecorators = {
            inset: [{ type: core.Input }],
            padded: [{ type: core.Input }]
        };
        return MdcListDivider;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var hasNativeClosest = typeof Element !== 'undefined' && !!Element.prototype.closest;
    /** IE 11 compatible closest implementation that is able to start from non-Element Nodes. */
    function closest(element, selector) {
        if (!(element instanceof Node)) {
            return null;
        }
        var curr = element;
        while (curr != null && !(curr instanceof Element)) {
            curr = curr.parentNode;
        }
        return curr && (hasNativeClosest ?
            curr.closest(selector) : polyfillClosest(curr, selector));
    }
    /** Polyfill for browsers without Element.closest. */
    function polyfillClosest(element, selector) {
        var curr = element;
        while (curr != null && !(curr instanceof Element && matches(curr, selector))) {
            curr = curr.parentNode;
        }
        return (curr || null);
    }
    /** IE 11 compatible matches implementation. */
    function matches(element, selector) {
        return element.matches ?
            element.matches(selector) :
            element['msMatchesSelector'](selector);
    }

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcRipple = /** @class */ (function () {
        function MdcRipple(element, foundation) {
            this.element = element;
            this.initialized = false;
            this._foundation = foundation || new ripple.MDCRippleFoundation(MdcRipple.createAdapter({
                _root: element.nativeElement
            }));
        }
        MdcRipple.createAdapter = function (instance) {
            var adapter = {
                addClass: function (className) { return instance._root.classList.add(className); },
                removeClass: function (className) { return instance._root.classList.remove(className); },
                browserSupportsCssVars: function () { return typeof window !== 'undefined' ? ripple.util.supportsCssVariables(window) : false; },
                isUnbounded: function () { return coercion.coerceBooleanProperty(instance.unbounded); },
                isSurfaceActive: function () { return matches(instance._root, ':active'); },
                isSurfaceDisabled: function () { return coercion.coerceBooleanProperty(instance.disabled); },
                containsEventTarget: function (target) { return instance._root.contains(target); },
                registerDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                deregisterDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                registerResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.addEventListener('resize', handler) : {}; },
                deregisterResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.removeEventListener('resize', handler) : {}; },
                updateCssVariable: function (varName, value) {
                    return instance._root.style.setProperty(varName, value);
                },
                computeBoundingRect: function () { return typeof document === 'object' && !!document ?
                    instance._root.getBoundingClientRect() : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); },
                getWindowPageOffset: function () { return typeof window !== 'undefined' ?
                    ({ x: window.pageXOffset, y: window.pageYOffset }) : ({ x: 0, y: 0 }); },
                registerInteractionHandler: function (evtType, handler) {
                    return instance._root.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                },
                deregisterInteractionHandler: function (evtType, handler) {
                    return instance._root.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }
            };
            return adapter;
        };
        MdcRipple.prototype.init = function () {
            if (!this.initialized) {
                this._foundation.init();
                this.initialized = true;
            }
        };
        MdcRipple.prototype.destroy = function () {
            if (this.initialized) {
                this.initialized = false;
                this._foundation.destroy();
            }
        };
        MdcRipple.prototype.layout = function () {
            this._foundation.layout();
        };
        MdcRipple.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        MdcRipple.prototype.activateRipple = function (event) {
            var _this = this;
            setTimeout(function () { return _this._foundation.activate(event); });
        };
        MdcRipple.prototype.deactivateRipple = function () {
            var _this = this;
            setTimeout(function () { return _this._foundation.deactivate(); });
        };
        MdcRipple.prototype.handleBlur = function () {
            this._foundation.handleBlur();
        };
        MdcRipple.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        MdcRipple.ctorParameters = function () { return [
            { type: core.ElementRef },
            { type: ripple.MDCRippleFoundation, decorators: [{ type: core.Optional }] }
        ]; };
        return MdcRipple;
    }());

    var MdcRippleDirective = /** @class */ (function () {
        function MdcRippleDirective(_ripple, elementRef) {
            this._ripple = _ripple;
            this.elementRef = elementRef;
            this._primary = false;
            this._secondary = false;
            this._disabled = false;
            this._unbounded = false;
            this._root = this.elementRef.nativeElement;
            this._ripple = this._createRipple();
        }
        Object.defineProperty(MdcRippleDirective.prototype, "attachTo", {
            get: function () {
                return this._attachTo;
            },
            set: function (element) {
                var _a, _b;
                this._attachTo = element;
                (_b = (_a = this._attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('mdc-ripple-surface');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "primary", {
            get: function () {
                return this._primary;
            },
            set: function (value) {
                this._primary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "secondary", {
            get: function () {
                return this._secondary;
            },
            set: function (value) {
                this._secondary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "unbounded", {
            get: function () {
                return this._unbounded;
            },
            set: function (value) {
                this._unbounded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcRippleDirective.prototype.ngOnChanges = function (changes) {
            if (changes['primary'] && this.attachTo) {
                if (this._primary) {
                    this.attachTo.classList.add('mdc-ripple-surface--primary');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--primary');
                }
            }
            if (changes['secondary'] && this.attachTo) {
                if (this._secondary) {
                    this.attachTo.classList.add('mdc-ripple-surface--accent');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--accent');
                }
            }
        };
        MdcRippleDirective.prototype.ngAfterViewInit = function () {
            this._ripple.init();
        };
        MdcRippleDirective.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcRippleDirective.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { addClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add(className); }, computeBoundingRect: function () { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); }, isSurfaceActive: function () { return matches(_this.attachTo, ':active'); }, isSurfaceDisabled: function () { return _this._disabled; }, isUnbounded: function () { return _this._unbounded; }, removeClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className); }, updateCssVariable: function (varName, value) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty(varName, value); }, registerInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()); }, deregisterInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()); } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcRippleDirective.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcRipple], mdc-ripple',
                        providers: [MdcRipple],
                    },] }
        ];
        /** @nocollapse */
        MdcRippleDirective.ctorParameters = function () { return [
            { type: MdcRipple },
            { type: core.ElementRef }
        ]; };
        MdcRippleDirective.propDecorators = {
            attachTo: [{ type: core.Input }],
            primary: [{ type: core.Input }],
            secondary: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            unbounded: [{ type: core.Input }]
        };
        return MdcRippleDirective;
    }());

    var MdcRippleModule = /** @class */ (function () {
        function MdcRippleModule() {
        }
        MdcRippleModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [MdcRippleDirective],
                        declarations: [MdcRippleDirective]
                    },] }
        ];
        return MdcRippleModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    /** Change event that is fired whenever the selected state of an option changes. */
    var MdcListSelectionChange = /** @class */ (function () {
        function MdcListSelectionChange(source) {
            this.source = source;
        }
        return MdcListSelectionChange;
    }());
    /**
     * Injection token used to provide the parent MdcList component to MdcListItem.
     */
    var MDC_LIST_PARENT_COMPONENT = new core.InjectionToken('MDC_LIST_PARENT_COMPONENT');
    var uniqueIdCounter = 0;
    var MdcListItemGraphic = /** @class */ (function () {
        function MdcListItemGraphic(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemGraphic.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcListItemGraphic], mdc-list-item-graphic',
                        exportAs: 'mdcListItemGraphic',
                        host: {
                            'role': 'presentation',
                            'class': 'mdc-list-item__graphic',
                            '[attr.aria-hidden]': 'true'
                        }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemGraphic.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcListItemGraphic;
    }());
    var MdcListItemMeta = /** @class */ (function () {
        function MdcListItemMeta(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemMeta.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcListItemMeta], mdc-list-item-meta',
                        exportAs: 'mdcListItemMeta',
                        host: { 'class': 'mdc-list-item__meta' }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemMeta.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcListItemMeta;
    }());
    var MdcListItemText = /** @class */ (function () {
        function MdcListItemText(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemText.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcListItemText], mdc-list-item-text',
                        exportAs: 'mdcListItemText',
                        host: { 'class': 'mdc-list-item__text' },
                        template: "\n  <ng-container>\n    <span class=\"mdc-list-item__primary-text\"><ng-content></ng-content></span>\n    <span class=\"mdc-list-item__secondary-text\" *ngIf=\"secondaryText\">{{secondaryText}}</span>\n  </ng-container>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListItemText.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcListItemText.propDecorators = {
            secondaryText: [{ type: core.Input }]
        };
        return MdcListItemText;
    }());
    var MdcListItemSecondary = /** @class */ (function () {
        function MdcListItemSecondary(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemSecondary.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcListItemSecondary], mdc-list-item-secondary',
                        exportAs: 'mdcListItemSecondary',
                        host: { 'class': 'mdc-list-item__secondary-text' }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemSecondary.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcListItemSecondary;
    }());
    var MdcListItem = /** @class */ (function () {
        function MdcListItem(ripple, _changeDetectorRef, elementRef, _parent) {
            this.ripple = ripple;
            this._changeDetectorRef = _changeDetectorRef;
            this.elementRef = elementRef;
            this._parent = _parent;
            this._id = "mdc-list-item-" + uniqueIdCounter++;
            this.tabIndex = -1;
            this._selected = false;
            this._activated = false;
            this._disabled = false;
            this.selectionChange = new core.EventEmitter();
            this._root = this.elementRef.nativeElement;
            this.ripple = this._createRipple();
            this.ripple.init();
        }
        Object.defineProperty(MdcListItem.prototype, "id", {
            /** The unique ID of the list item. */
            get: function () {
                return this._id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "selected", {
            /** Whether the list item is selected. */
            get: function () {
                return this._selected;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._selected) {
                    this._selected = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "activated", {
            /** Whether the list item is activated. */
            get: function () {
                return this._activated;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._activated) {
                    this._activated = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "disabled", {
            /** Whether the list item is disabled. */
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._disabled) {
                    this._disabled = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcListItem.prototype.ngOnDestroy = function () {
            this.ripple.destroy();
        };
        MdcListItem.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { isSurfaceDisabled: function () { return _this._disabled || _this._parent.disableRipple; } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcListItem.prototype.focus = function () {
            this.getListItemElement().focus();
        };
        MdcListItem.prototype.setRole = function (role) {
            this.getListItemElement().setAttribute('role', role);
        };
        MdcListItem.prototype.getListItemElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcListItem.prototype._onKeydown = function (evt) {
            if (evt.keyCode === keycodes.ENTER || evt.keyCode === keycodes.SPACE) {
                this._emitChangeEvent();
            }
        };
        /** Emits a change event if the selected state of an option changed. */
        MdcListItem.prototype._emitChangeEvent = function () {
            if (this._disabled) {
                return;
            }
            this.selectionChange.emit(new MdcListSelectionChange(this));
        };
        MdcListItem.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-list-item, a[mdc-list-item]',
                        exportAs: 'mdcListItem',
                        host: {
                            'role': 'listitem',
                            '[id]': 'id',
                            '[tabIndex]': 'tabIndex',
                            'class': 'mdc-list-item',
                            '[attr.data-value]': 'value',
                            '[class.mdc-list-item--selected]': 'selected',
                            '[class.mdc-list-item--activated]': 'activated',
                            '[class.mdc-list-item--disabled]': 'disabled',
                            '(click)': '_emitChangeEvent()',
                            '(keydown)': '_onKeydown($event)'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        providers: [MdcRipple]
                    }] }
        ];
        /** @nocollapse */
        MdcListItem.ctorParameters = function () { return [
            { type: MdcRipple },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MDC_LIST_PARENT_COMPONENT,] }] }
        ]; };
        MdcListItem.propDecorators = {
            value: [{ type: core.Input }],
            tabIndex: [{ type: core.Input }],
            selected: [{ type: core.Input }],
            activated: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            selectionChange: [{ type: core.Output }]
        };
        return MdcListItem;
    }());

    /** Change event that is being fired whenever the selected state of an option changes. */
    var MdcListItemChange = /** @class */ (function () {
        function MdcListItemChange(
        /** Reference to the selection list that emitted the event. */
        source, 
        /** Reference to the option that has been changed. */
        option) {
            this.source = source;
            this.option = option;
        }
        return MdcListItemChange;
    }());
    var MdcListGroup = /** @class */ (function () {
        function MdcListGroup(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListGroup.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcListGroup], mdc-list-group',
                        exportAs: 'mdcListGroup',
                        host: { 'class': 'mdc-list-group' },
                        template: "\n  <h3 class=\"mdc-list-group__subheader\" *ngIf=\"subheader\">{{subheader}}</h3>\n  <ng-content></ng-content>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListGroup.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcListGroup.propDecorators = {
            subheader: [{ type: core.Input }]
        };
        return MdcListGroup;
    }());
    var MdcListGroupSubheader = /** @class */ (function () {
        function MdcListGroupSubheader(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListGroupSubheader.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcListGroupSubheader], mdc-list-group-subheader',
                        exportAs: 'mdcListGroupSubheader',
                        host: { 'class': 'mdc-list-group__subheader' }
                    },] }
        ];
        /** @nocollapse */
        MdcListGroupSubheader.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcListGroupSubheader;
    }());
    var MdcList = /** @class */ (function (_super) {
        __extends(MdcList, _super);
        function MdcList(_platform, _changeDetectorRef, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this._twoLine = false;
            _this._dense = false;
            _this._border = false;
            _this._avatar = false;
            _this._interactive = true;
            _this._disableRipple = false;
            _this._useActivatedClass = false;
            _this._useSelectedClass = false;
            _this._verticalOrientation = true;
            _this._wrapFocus = false;
            /** Emits a change event whenever the selected state of an option changes. */
            _this.selectionChange = new core.EventEmitter();
            /** Emits an event for keyboard and mouse actions. */
            _this.actionEvent = new core.EventEmitter();
            /** Subscription to changes in list items. */
            _this._changeSubscription = null;
            /** Subscription to selection events in list items. */
            _this.itemSelectionSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcList.prototype, "twoLine", {
            get: function () {
                return this._twoLine;
            },
            set: function (value) {
                this._twoLine = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "dense", {
            get: function () {
                return this._dense;
            },
            set: function (value) {
                this._dense = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "border", {
            get: function () {
                return this._border;
            },
            set: function (value) {
                this._border = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "avatar", {
            get: function () {
                return this._avatar;
            },
            set: function (value) {
                this._avatar = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "interactive", {
            get: function () {
                return this._interactive;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._interactive) {
                    this._interactive = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "disableRipple", {
            get: function () {
                return this._disableRipple;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._disableRipple) {
                    this._disableRipple = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "singleSelection", {
            get: function () {
                return this._singleSelection;
            },
            set: function (value) {
                if (value !== undefined) {
                    var newValue = coercion.coerceBooleanProperty(value);
                    if (newValue !== this._singleSelection) {
                        this._singleSelection = newValue;
                        this._foundation.setSingleSelection(this._singleSelection);
                        this._changeDetectorRef.markForCheck();
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "useActivatedClass", {
            get: function () {
                return this._useActivatedClass;
            },
            set: function (value) {
                this._useActivatedClass = coercion.coerceBooleanProperty(value);
                this._foundation.setUseActivatedClass(this._useActivatedClass);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "useSelectedClass", {
            get: function () {
                return this._useSelectedClass;
            },
            set: function (value) {
                this._useSelectedClass = coercion.coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "verticalOrientation", {
            get: function () {
                return this._verticalOrientation;
            },
            set: function (value) {
                this._verticalOrientation = coercion.coerceBooleanProperty(value);
                this._foundation.setVerticalOrientation(this._verticalOrientation);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "wrapFocus", {
            get: function () {
                return this._wrapFocus;
            },
            set: function (value) {
                this._wrapFocus = coercion.coerceBooleanProperty(value);
                this._foundation.setWrapFocus(this._wrapFocus);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "listItemSelections", {
            /** Combined stream of all of the list item selection events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.items.map(function (item) { return item.selectionChange; })));
            },
            enumerable: true,
            configurable: true
        });
        MdcList.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                getListItemCount: function () { return _this.items.length; },
                getFocusedElementIndex: function () {
                    if (!_this._platform.isBrowser && document.activeElement) {
                        return -1;
                    }
                    return _this.items.toArray().findIndex(function (_) { return _.getListItemElement() === document.activeElement; }) || -1;
                },
                setAttributeForElementIndex: function (index, attr, value) {
                    var _a;
                    var item = _this.getListItemByIndex(index);
                    (_a = item === null || item === void 0 ? void 0 : item.getListItemElement()) === null || _a === void 0 ? void 0 : _a.setAttribute(attr, value);
                },
                addClassForElementIndex: function (index, className) {
                    return _this.items.toArray()[index].getListItemElement().classList.add(className);
                },
                removeClassForElementIndex: function (index, className) {
                    var _a, _b;
                    var item = _this.getListItemByIndex(index);
                    (_b = (_a = item === null || item === void 0 ? void 0 : item.getListItemElement()) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className);
                },
                getAttributeForElementIndex: function (index, attr) {
                    return _this.items.toArray()[index].getListItemElement().getAttribute(attr);
                },
                focusItemAtIndex: function (index) { return _this.focusItemAtIndex(index); },
                setTabIndexForListItemChildren: function (listItemIndex, tabIndexValue) {
                    var listItemChildren = [].slice.call(_this.items.toArray()[listItemIndex].getListItemElement()
                        .querySelectorAll(list.strings.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX));
                    listItemChildren.forEach(function (ele) { return ele.setAttribute('tabindex', "" + tabIndexValue); });
                },
                hasCheckboxAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    return !!listItem.querySelector(list.strings.CHECKBOX_SELECTOR);
                },
                hasRadioAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    return !!listItem.querySelector(list.strings.RADIO_SELECTOR);
                },
                isCheckboxCheckedAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    var toggleEl = listItem.querySelector(list.strings.CHECKBOX_SELECTOR);
                    return toggleEl.checked;
                },
                setCheckedCheckboxOrRadioAtIndex: function (index, isChecked) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    var toggleEl = listItem.querySelector(list.strings.CHECKBOX_RADIO_SELECTOR);
                    toggleEl.checked = isChecked;
                    if (_this._platform.isBrowser) {
                        var event_1 = document.createEvent('Event');
                        event_1.initEvent('change', true, true);
                        toggleEl.dispatchEvent(event_1);
                    }
                },
                isFocusInsideList: function () { return _this._platform.isBrowser ?
                    _this.elementRef.nativeElement.contains(document.activeElement) : false; },
                isRootFocused: function () { return _this._platform.isBrowser ? document.activeElement === _this._getHostElement() : false; },
                listItemAtIndexHasClass: function (index, className) {
                    return _this.items.toArray()[index].getListItemElement().classList.contains(className);
                },
                notifyAction: function (index) { return _this.actionEvent.emit({ index: index }); }
            };
            return new list.MDCListFoundation(adapter);
        };
        MdcList.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._foundation.init();
            this._foundation.layout();
            // When list items change, re-subscribe
            this._changeSubscription = this.items.changes.pipe(operators.startWith(null))
                .subscribe(function () {
                if (_this.items.length) {
                    _this._resetListItems();
                }
            });
        };
        MdcList.prototype.ngOnDestroy = function () {
            var _a;
            this._dropSubscriptions();
            (_a = this._changeSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            this._foundation.destroy();
        };
        MdcList.prototype.setSelectedIndex = function (index) {
            this.reset();
            this._foundation.setSelectedIndex(index);
            if (index === -1) {
                return;
            }
            var selectedItem = this.items.toArray()[index];
            if (selectedItem) {
                this._applySelectionState(selectedItem);
            }
        };
        MdcList.prototype.setSelectedValue = function (value) {
            this.reset();
            if (value === null) {
                return;
            }
            var selectedItem = this.getListItemByValue(value);
            this._foundation.setSelectedIndex(this.getListItemIndexByValue(value));
            if (selectedItem) {
                this._applySelectionState(selectedItem);
            }
        };
        MdcList.prototype.getSelectedItem = function () {
            return this.items.toArray().find(function (_) { return _.selected || _.activated; });
        };
        MdcList.prototype.getSelectedIndex = function () {
            return this.items.toArray().findIndex(function (_) { return _.selected || _.activated; });
        };
        MdcList.prototype.getSelectedValue = function () {
            var item = this.items ? this.items.find(function (_) { return _.selected; }) : null;
            return item && item.value ? item.value : null;
        };
        MdcList.prototype.getSelectedText = function () {
            var selectedItem = this.getSelectedItem();
            return selectedItem && selectedItem.getListItemElement().textContent || '';
        };
        MdcList.prototype.getListItemByValue = function (value) {
            return this.items.toArray().find(function (_) { return _.value === value; });
        };
        MdcList.prototype.getListItemByIndex = function (index) {
            return this.items.toArray()[index];
        };
        MdcList.prototype.getListItemIndexByValue = function (value) {
            return this.items.toArray().findIndex(function (_) { return _.value === value; });
        };
        MdcList.prototype.focusItemAtIndex = function (index) {
            this.items.toArray()[index].getListItemElement().focus();
        };
        MdcList.prototype.focusFirstElement = function () {
            return this._foundation.focusFirstElement();
        };
        MdcList.prototype.focusLastElement = function () {
            return this._foundation.focusLastElement();
        };
        MdcList.prototype.focusNextElement = function (index) {
            return this._foundation.focusNextElement(index);
        };
        MdcList.prototype.focusPrevElement = function (index) {
            return this._foundation.focusPrevElement(index);
        };
        MdcList.prototype.setRole = function (role) {
            this._getHostElement().setAttribute('role', role);
        };
        MdcList.prototype.setTabIndex = function (index) {
            this._getHostElement().tabIndex = index;
        };
        MdcList.prototype.focus = function () {
            this._getHostElement().focus();
        };
        MdcList.prototype.reset = function () {
            this.items.forEach(function (_) {
                _.selected = false;
                _.activated = false;
            });
        };
        MdcList.prototype._applySelectionState = function (item) {
            if (this.useActivatedClass) {
                item.activated = true;
            }
            else if (this.useSelectedClass) {
                item.selected = true;
            }
        };
        MdcList.prototype._resetListItems = function () {
            this._dropSubscriptions();
            this._listenForListItemSelection();
        };
        MdcList.prototype._dropSubscriptions = function () {
            if (this.itemSelectionSubscription) {
                this.itemSelectionSubscription.unsubscribe();
                this.itemSelectionSubscription = null;
            }
        };
        /** Listens to selected events on each list item. */
        MdcList.prototype._listenForListItemSelection = function () {
            var _this = this;
            this.itemSelectionSubscription = this.listItemSelections.subscribe(function (event) {
                if (_this.singleSelection) {
                    _this.items.filter(function (_) { return _.id !== event.source.id && (_.activated || _.selected); })
                        .forEach(function (_) {
                        _.selected = false;
                        _.activated = false;
                    });
                }
                _this._applySelectionState(event.source);
                if (!_this.singleSelection) {
                    event.source.ripple.handleBlur();
                }
                _this.selectionChange.emit(new MdcListItemChange(_this, event.source));
            });
        };
        MdcList.prototype._onFocusIn = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            this._foundation.handleFocusIn(evt, index);
        };
        MdcList.prototype._onFocusOut = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            if (index >= 0) {
                this._foundation.handleFocusOut(evt, index);
            }
        };
        MdcList.prototype._onKeydown = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            var target = evt.target;
            if (index >= 0) {
                this._foundation.handleKeydown(evt, target.classList.contains(list.cssClasses.LIST_ITEM_CLASS), index);
            }
        };
        MdcList.prototype._handleClickEvent = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            var target = evt.target;
            var listItem = this._getListItemByEventTarget(evt.target);
            if (listItem && listItem.disabled) {
                return;
            }
            // Toggle the checkbox only if it's not the target of the event, or the checkbox will have 2 change events.
            var toggleCheckbox = !matches(target, list.strings.CHECKBOX_RADIO_SELECTOR);
            this._foundation.handleClick(index, toggleCheckbox);
        };
        MdcList.prototype._getListItemByEventTarget = function (target) {
            return this.items.toArray().find(function (_) { return _.getListItemElement() === target; });
        };
        MdcList.prototype._getListItemIndexByEvent = function (evt) {
            return this.items.toArray().findIndex(function (_) { return _.getListItemElement() === evt.target; });
        };
        /** Retrieves the DOM element of the component host. */
        MdcList.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcList.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-list',
                        exportAs: 'mdcList',
                        host: {
                            'role': 'list',
                            'class': 'mdc-list',
                            '[attr.aria-orientation]': 'verticalOrientation ? "vertical" : "horizontal"',
                            '[class.mdc-list--dense]': 'dense',
                            '[class.mdc-list--avatar-list]': 'avatar',
                            '[class.ngx-mdc-list--border]': 'border',
                            '[class.mdc-list--non-interactive]': '!interactive',
                            '[class.mdc-list--two-line]': 'twoLine',
                            '(click)': '_handleClickEvent($event)',
                            '(keydown)': '_onKeydown($event)',
                            '(focusin)': '_onFocusIn($event)',
                            '(focusout)': '_onFocusOut($event)'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        providers: [{ provide: MDC_LIST_PARENT_COMPONENT, useExisting: MdcList }]
                    }] }
        ];
        /** @nocollapse */
        MdcList.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef }
        ]; };
        MdcList.propDecorators = {
            twoLine: [{ type: core.Input }],
            dense: [{ type: core.Input }],
            border: [{ type: core.Input }],
            avatar: [{ type: core.Input }],
            interactive: [{ type: core.Input }],
            disableRipple: [{ type: core.Input }],
            singleSelection: [{ type: core.Input }],
            useActivatedClass: [{ type: core.Input }],
            useSelectedClass: [{ type: core.Input }],
            verticalOrientation: [{ type: core.Input }],
            wrapFocus: [{ type: core.Input }],
            items: [{ type: core.ContentChildren, args: [MdcListItem, { descendants: true },] }],
            selectionChange: [{ type: core.Output }],
            actionEvent: [{ type: core.Output }]
        };
        return MdcList;
    }(MDCComponent));

    var LIST_DECLARATIONS = [
        MdcList,
        MdcListDivider,
        MdcListGroup,
        MdcListGroupSubheader,
        MdcListItem,
        MdcListItemGraphic,
        MdcListItemMeta,
        MdcListItemSecondary,
        MdcListItemText
    ];
    var MdcListModule = /** @class */ (function () {
        function MdcListModule() {
        }
        MdcListModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: LIST_DECLARATIONS,
                        declarations: LIST_DECLARATIONS,
                    },] }
        ];
        return MdcListModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcDrawerHeader = /** @class */ (function () {
        function MdcDrawerHeader(elementRef) {
            this.elementRef = elementRef;
        }
        MdcDrawerHeader.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-drawer-header',
                        template: "\n  <ng-content></ng-content>\n  <h3 class=\"mdc-drawer__title\" *ngIf=\"title\">{{title}}</h3>\n  <h6 class=\"mdc-drawer__subtitle\" *ngIf=\"subtitle\">{{subtitle}}</h6>",
                        host: { 'class': 'mdc-drawer__header' },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcDrawerHeader.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcDrawerHeader.propDecorators = {
            title: [{ type: core.Input }],
            subtitle: [{ type: core.Input }]
        };
        return MdcDrawerHeader;
    }());
    var MdcDrawer = /** @class */ (function (_super) {
        __extends(MdcDrawer, _super);
        function MdcDrawer(_platform, _ngZone, _changeDetectorRef, _focusTrapFactory, _focusMonitor, _document, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._focusTrapFactory = _focusTrapFactory;
            _this._focusMonitor = _focusMonitor;
            _this._document = _document;
            _this.elementRef = elementRef;
            /** Emits when the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._scrimElement = null;
            /** Element that was focused before the drawer was opened. Save this to restore upon close. */
            _this._elementFocusedBeforeDrawerWasOpened = null;
            _this._open = false;
            _this._drawer = '';
            _this._autoFocus = true;
            _this._restoreFocus = true;
            _this.opened = new core.EventEmitter();
            _this.closed = new core.EventEmitter();
            /** Event emitted when the drawer open state is changed. */
            _this.openedChange = new core.EventEmitter(/* isAsync */ true);
            /** Event emitted when the drawer variant is changed. */
            _this.drawerChange = new core.EventEmitter(/* isAsync */ true);
            _this._scrimSubscription = null;
            _this.openedChange.subscribe(function (opened) {
                if (opened) {
                    if (_this._document) {
                        _this._elementFocusedBeforeDrawerWasOpened = _this._document.activeElement;
                    }
                    if (_this._isFocusTrapEnabled && _this._focusTrap) {
                        _this._trapFocus();
                    }
                }
                else {
                    _this._releaseFocus();
                }
            });
            _this.drawerChange.subscribe(function () { return _this._initFoundation(); });
            /**
             * Listen to `keydown` events outside the zone so that change detection is not run every
             * time a key is pressed. Instead we re-enter the zone only if the `ESC` key is pressed
             * and we don't have close disabled.
             */
            _this._ngZone.runOutsideAngular(function () {
                rxjs.fromEvent(_this._elementRef.nativeElement, 'keydown')
                    .pipe(operators.takeUntil(_this._destroyed)).subscribe(function (event) { return _this._ngZone.run(function () {
                    _this._foundation.handleKeydown(event);
                    if (_this.modal) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                }); });
            });
            return _this;
        }
        Object.defineProperty(MdcDrawer.prototype, "open", {
            get: function () {
                return this._open;
            },
            set: function (value) {
                if (this._platform.isBrowser && this._open !== value) {
                    this._open = coercion.coerceBooleanProperty(value);
                    this._open ? this._foundation.open() : this._foundation.close();
                    this.openedChange.emit(this._open);
                    this._updateFocusTrapState();
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "drawer", {
            get: function () {
                return this._drawer;
            },
            set: function (drawer) {
                if (this._drawer !== drawer) {
                    this._drawer = drawer;
                    this.drawerChange.emit();
                    this._updateFocusTrapState();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "autoFocus", {
            get: function () {
                return this._autoFocus;
            },
            set: function (value) {
                this._autoFocus = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "restoreFocus", {
            get: function () {
                return this._restoreFocus;
            },
            set: function (value) {
                this._restoreFocus = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "fixedAdjustElement", {
            get: function () {
                return this._fixedAdjustElement;
            },
            set: function (element) {
                this._fixedAdjustElement = element;
                element ? this._getHostElement().style.setProperty('position', 'absolute') :
                    this._getHostElement().style.removeProperty('position');
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "modal", {
            get: function () {
                return this.drawer === 'modal';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "dismissible", {
            get: function () {
                return this.drawer === 'dismissible';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "_isFocusTrapEnabled", {
            get: function () {
                // The focus trap is only enabled when the drawer is open and modal.
                return this.open && this.modal;
            },
            enumerable: true,
            configurable: true
        });
        MdcDrawer.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                elementHasClass: function (element, className) { return element.classList.contains(className); },
                saveFocus: function () { return _this._savePreviouslyFocusedElement(); },
                restoreFocus: function () { return _this._releaseFocus(); },
                focusActiveNavigationItem: function () {
                    if (!_this._platform.isBrowser || !_this._list || !_this._autoFocus) {
                        return;
                    }
                    var selectedItem = _this._list.getSelectedItem();
                    if (selectedItem) {
                        selectedItem.focus();
                    }
                    else {
                        var cdkInitialItem = _this._platform.isBrowser ?
                            document.querySelector("[cdkFocusInitial]") : null;
                        cdkInitialItem === null || cdkInitialItem === void 0 ? void 0 : cdkInitialItem.focus();
                    }
                },
                notifyClose: function () { return _this.closed.emit(); },
                notifyOpen: function () { return _this.opened.emit(); },
                trapFocus: function () { },
                releaseFocus: function () { return _this._releaseFocus(); }
            };
            return this.modal ? new drawer.MDCModalDrawerFoundation(adapter) : new drawer.MDCDismissibleDrawerFoundation(adapter);
        };
        MdcDrawer.prototype.ngAfterContentInit = function () {
            this._initListType();
        };
        MdcDrawer.prototype.ngOnDestroy = function () {
            var _a, _b, _c;
            this.open = false;
            (_a = this._focusTrap) === null || _a === void 0 ? void 0 : _a.destroy();
            (_b = this._scrimElement) === null || _b === void 0 ? void 0 : _b.remove();
            (_c = this._scrimSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
            this._destroyed.next();
            this._destroyed.complete();
            if (this._foundation && this._platform.isBrowser) {
                this._foundation.destroy();
            }
        };
        MdcDrawer.prototype._handleTransitionEnd = function (event) {
            this._foundation.handleTransitionEnd(event);
        };
        MdcDrawer.prototype._createScrim = function () {
            var _this = this;
            if (this._platform.isBrowser) {
                this._scrimElement = document.createElement('div');
                this._scrimElement.classList.add('mdc-drawer-scrim');
                this._getHostElement().insertAdjacentElement('afterend', this._scrimElement);
                this._scrimSubscription =
                    this._ngZone.runOutsideAngular(function () {
                        return rxjs.fromEvent(_this._scrimElement, 'click')
                            .subscribe(function () { return _this._ngZone.run(function () { return _this.open = false; }); });
                    });
            }
        };
        MdcDrawer.prototype._initFoundation = function () {
            this._getHostElement().classList.remove(drawer.cssClasses.MODAL);
            this._getHostElement().classList.remove(drawer.cssClasses.DISMISSIBLE);
            this._foundation = this.getDefaultFoundation();
            this._foundation.init();
            if (this.modal || this.dismissible) {
                this._getHostElement().classList.add(drawer.cssClasses.ROOT + "--" + this.drawer);
            }
            if (this._scrimElement) {
                if (this._scrimSubscription) {
                    this._scrimSubscription.unsubscribe();
                }
                this._scrimElement.remove();
                this._scrimElement = null;
            }
            if (this.modal) {
                this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
                this._updateFocusTrapState();
                this._createScrim();
            }
            else if (this._focusTrap) {
                this._focusTrap.destroy();
            }
            this._changeDetectorRef.markForCheck();
        };
        MdcDrawer.prototype._initListType = function () {
            if (this._list && (this._list.singleSelection || this._list.singleSelection === undefined)) {
                this._list.wrapFocus = true;
                this._list.singleSelection = true;
                this._list.useActivatedClass = true;
            }
        };
        /** Updates the enabled state of the focus trap. */
        MdcDrawer.prototype._updateFocusTrapState = function () {
            if (this._focusTrap) {
                this._focusTrap.enabled = this._isFocusTrapEnabled;
            }
        };
        MdcDrawer.prototype._trapFocus = function () {
            var _this = this;
            if (!this.autoFocus) {
                return;
            }
            this._focusTrap.focusInitialElementWhenReady().then(function (hasMovedFocus) {
                // If there were no focusable elements, focus the drawer itself so the keyboard navigation
                // still works. We need to check that `focus` is a function due to Universal.
                if (!hasMovedFocus && typeof _this._elementRef.nativeElement.focus === 'function') {
                    _this._elementRef.nativeElement.focus();
                }
            });
        };
        /** Restores focus to the element that was focused before the drawer opened. */
        MdcDrawer.prototype._releaseFocus = function () {
            if (!this.autoFocus) {
                return;
            }
            var activeEl = this._document && this._document.activeElement;
            if (activeEl && this._elementRef.nativeElement.contains(activeEl)) {
                if (this._elementFocusedBeforeDrawerWasOpened instanceof HTMLElement) {
                    this._focusMonitor.focusVia(this._elementFocusedBeforeDrawerWasOpened, this._openedVia);
                }
                else {
                    this._elementRef.nativeElement.blur();
                }
            }
            this._elementFocusedBeforeDrawerWasOpened = null;
            this._openedVia = null;
        };
        /** Saves a reference to the element that was focused before the drawer was opened. */
        MdcDrawer.prototype._savePreviouslyFocusedElement = function () {
            var _this = this;
            if (this._document) {
                this._elementFocusedBeforeDrawerWasOpened = this._document.activeElement;
                // Note that there is no focus method when rendering on the server.
                if (this._elementRef.nativeElement.focus) {
                    // Move focus onto the drawer immediately. Needs to be async, because the element
                    // may not be focusable immediately.
                    Promise.resolve().then(function () { return _this._elementRef.nativeElement.focus(); });
                }
            }
        };
        MdcDrawer.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcDrawer.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-drawer',
                        exportAs: 'mdcDrawer',
                        host: {
                            'role': 'navigation',
                            'class': 'mdc-drawer',
                            '(transitionend)': '_handleTransitionEnd($event)'
                        },
                        template: '<ng-content></ng-content>',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcDrawer.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.NgZone },
            { type: core.ChangeDetectorRef },
            { type: a11y.FocusTrapFactory },
            { type: a11y.FocusMonitor },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] }] },
            { type: core.ElementRef }
        ]; };
        MdcDrawer.propDecorators = {
            open: [{ type: core.Input }],
            drawer: [{ type: core.Input }],
            autoFocus: [{ type: core.Input }],
            restoreFocus: [{ type: core.Input }],
            fixedAdjustElement: [{ type: core.Input }],
            opened: [{ type: core.Output }],
            closed: [{ type: core.Output }],
            openedChange: [{ type: core.Output }],
            drawerChange: [{ type: core.Output }],
            _list: [{ type: core.ContentChild, args: [MdcList, { static: false },] }]
        };
        return MdcDrawer;
    }(MDCComponent));

    var MdcDrawerTitle = /** @class */ (function () {
        function MdcDrawerTitle() {
        }
        MdcDrawerTitle.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDrawerTitle]',
                        host: { 'class': 'mdc-drawer__title' }
                    },] }
        ];
        return MdcDrawerTitle;
    }());
    var MdcDrawerSubtitle = /** @class */ (function () {
        function MdcDrawerSubtitle() {
        }
        MdcDrawerSubtitle.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDrawerSubtitle]',
                        host: { 'class': 'mdc-drawer__subtitle' }
                    },] }
        ];
        return MdcDrawerSubtitle;
    }());
    var MdcDrawerContent = /** @class */ (function () {
        function MdcDrawerContent() {
        }
        MdcDrawerContent.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-drawer-content, [mdcDrawerContent]',
                        host: { 'class': 'mdc-drawer__content' }
                    },] }
        ];
        return MdcDrawerContent;
    }());
    var MdcDrawerAppContent = /** @class */ (function () {
        function MdcDrawerAppContent() {
        }
        MdcDrawerAppContent.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-drawer-app-content, [mdcDrawerAppContent]',
                        host: { 'class': 'mdc-drawer-app-content' }
                    },] }
        ];
        return MdcDrawerAppContent;
    }());

    var DRAWER_DECLARATIONS = [
        MdcDrawer,
        MdcDrawerAppContent,
        MdcDrawerContent,
        MdcDrawerHeader,
        MdcDrawerSubtitle,
        MdcDrawerTitle
    ];
    var MdcDrawerModule = /** @class */ (function () {
        function MdcDrawerModule() {
        }
        MdcDrawerModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: [DRAWER_DECLARATIONS],
                        declarations: [DRAWER_DECLARATIONS]
                    },] }
        ];
        return MdcDrawerModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcDrawer = MdcDrawer;
    exports.MdcDrawerAppContent = MdcDrawerAppContent;
    exports.MdcDrawerContent = MdcDrawerContent;
    exports.MdcDrawerHeader = MdcDrawerHeader;
    exports.MdcDrawerModule = MdcDrawerModule;
    exports.MdcDrawerSubtitle = MdcDrawerSubtitle;
    exports.MdcDrawerTitle = MdcDrawerTitle;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-drawer.umd.js.map
